<template>
  <div class="institution-display">
    <!-- 页面标题 -->
    <achiTitle title="机构展示平台" subtitle="汇聚优质企业与高校资源，促进产学研合作" />

    <!-- 筛选区域 -->
    <div class="filter-bar">
      <el-input
        v-model="searchQuery"
        placeholder="搜索机构名称..."
        prefix-icon="Search"
        clearable
        class="search-input">
      </el-input>
      <el-button size="large" @click="searchByName">搜索</el-button>

      <el-select
        v-model="selectedType"
        placeholder="选择机构类型"
        clearable
        class="filter-select"
        @change="handleTypeChange">
        <el-option label="企业" value="1"></el-option>
        <el-option label="高校" value="2"></el-option>
      </el-select>
    </div>

    <!-- 机构展示区域 -->
    <div class="institutions-container">
      <!-- 无数据状态 -->
      <div v-if="cardDatas.length === 0 && !loading" class="no-results">
        <el-empty description="没有找到符合条件的机构信息"></el-empty>
      </div>

      <!-- 加载中状态 -->
      <div v-if="loading" class="loading-container">
        <el-loading type="circle" text="加载中..."></el-loading>
      </div>

      <!-- 机构卡片 -->
      <div class="institution-card" v-for="(institution, index) in cardDatas" :key="index" @click="goToDetail(institution)">
        <!-- 类型标签 - 右上角 -->
        <el-tag
          :type="getTypeTagType(institution.type)"
          class="type-tag">
          {{ institution.type === 1 ? '企业' : '高校' }}
        </el-tag>

        <!-- 封面图 - 卡片中间 -->
        <div class="card-image">
          <img
            :src="institution.introImage || defaultInstitutionImg"
            alt="机构封面图"
            @error="handleImgError">
        </div>

        <!-- 机构名称 - 醒目显示在下方 -->
        <div class="card-footer" >
          <h3 class="institution-name">{{ institution.name || '未知机构' }}</h3>
        </div>
      </div>
    </div>

    <!-- 分页组件 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[12, 24, 32]"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next,sizes"
        :total="total">
      </el-pagination>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import achiTitle from '../components/achievement/achi_title.vue';
import { loadPageData } from '@/utils/MyUtils.js'
import institutionApi from '@/api/institutions.js'

export default {
  name: 'InstitutionDisplay',
  components: {
    achiTitle
  },
  data() {
    return {
      // 筛选条件
      searchQuery: '',
      selectedType: '',
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 12,
        total: 0
      },
      // 数据相关
      cardDatas: [],
      loading: true,
      error: null,
      defaultInstitutionImg: require('@/assets/homepage/default-institution.png'), //默认图片路径
    };
  },
  computed: {
    // 动态拼接查询URL（分页+搜索+类型筛选）
    baseUrl() {
      const { currentPage, pageSize } = this.pagination;
      let url = `/institutions/page?pageNum=${currentPage}&pageSize=${pageSize}`;

      // 拼接搜索参数（机构名称模糊查询）
      if (this.searchQuery.trim()) {
        url += `&name=${encodeURIComponent(this.searchQuery.trim())}`;
      }
      // 拼接类型筛选参数
      if (this.selectedType) {
        url += `&type=${encodeURIComponent(this.selectedType)}`;
      }
      return url;
    }
  },
  watch: {
    // 监听搜索关键词变化
    searchQuery: {
      handler() {
        this.pagination.currentPage = 1;
        this.loadData(this.baseUrl);
      },
      immediate: false
    },
    // 监听机构类型筛选变化
    selectedType: {
      handler() {
        this.pagination.currentPage = 1;
        this.loadData(this.baseUrl);
      },
      immediate: false
    },
    // 监听路由变化
    $route: {
      handler() {
        this.loadData(this.baseUrl);
      },
      immediate: false
    }
  },
  created() {
    // 组件创建时加载初始数据
    this.loadData(this.baseUrl);
  },
  methods: {
    // 加载机构数据
    async loadData(url) {
      try {
        this.loading = true;
        let data = await loadPageData(this, url);
        this.total = data.total || 0;
        this.cardDatas = data.records || [];
        console.log(this.cardDatas)
        this.error = null;
      } catch (err) {
        this.error = '数据加载失败，请刷新页面重试';
        this.cardDatas = [];
        console.error('加载机构数据出错:', err);
      } finally {
        this.loading = false;
      }
    },
    // 获取类型标签样式：学校(高校)蓝色(primary)，企业黄色(warning)
    getTypeTagType(type) {
      return type === 2 ? 'primary' : 'warning';
    },

    // 跳转到机构详情页
    goToDetail(institution) {
      this.$router.push({
        name: 'InstitutionDetail',
        params: { id: institution.id }
      });
    },
    // 每页数量变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.loadData(this.baseUrl);
    },
    // 当前页码变化
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.loadData(this.baseUrl);
    },
    // 搜索按钮点击
    searchByName() {
      this.pagination.currentPage = 1;
      this.loadData(this.baseUrl);
    },
    // 类型筛选变化处理
    handleTypeChange(value) {
      this.selectedType = value;
    },
    //图片加载失败
    handleImgError(e) {
      if (e.target.src !== this.defaultInstitutionImg) {
        e.target.src = this.defaultInstitutionImg;
      }
    }
  }
};
</script>

<style scoped>
.institution-display {
  max-width: 85%;
  margin: 0 auto;
  padding: 20px;
}

/* 筛选区域样式 */
.filter-bar {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.filter-select {
  width: 200px;
}

.search-input {
  width: 300px;
  min-width: 180px;
}

/* 机构展示容器 */
.institutions-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 30px;
  position: relative;
}

/* 加载中样式 */
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

/* 机构卡片样式 */
.institution-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  /* 为类型标签定位做准备 */
  height: 320px;
  /* 固定卡片高度，保证布局统一 */
  display: flex;
  flex-direction: column;
}

.institution-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

/* 类型标签 - 右上角 */
.type-tag {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
  width: 60px;
  text-align: center;
}

/* 封面图区域 - 卡片中间 */
.card-image {
  height: 220px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f8f9fa;
}

.card-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 50%;
}

/* 卡片底部（机构名称+按钮） */
.card-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
}

.institution-name {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
  margin: 0 0 12px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 无数据样式 */
.no-results {
  text-align: center;
  padding: 60px 0;
  grid-column: 1 / -1;
}

/* 分页样式 */
.pagination {
  text-align: center;
  margin-top: 30px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .institution-display {
    max-width: 95%;
    padding: 15px;
  }

  .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-select,
  .search-input {
    width: 100%;
  }

  .institutions-container {
    grid-template-columns: 1fr;
  }

  .institution-card {
    height: 280px;
  }
}

@media (min-width: 769px) and (max-width: 1200px) {
  .institutions-container {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}
</style>